/* __next_internal_client_entry_do_not_use__ IntlProviderForSSR_Base auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { localeStringToLocaleKey } from "@faire/web--source/common/consts/TWO_TO_THREE_LETTER_LANGUAGE_CODE";
import { IntlProvider } from "@faire/web--source/common/localization/IntlProvider";
import { getTranslationLocale } from "@faire/web--source/common/rsc/localization/utils";
import { isWindowUndefined } from "@faire/web--source/common/server-side-rendering/isWindowUndefined";
import fs from "fs";
import React from "react";
export var IntlProviderForSSR_Base = function(param) {
    var children = param.children, locale = param.locale;
    if (!isWindowUndefined()) {
        return children;
    }
    var localizationLocale = getTranslationLocale(locale);
    var localeKey = localeStringToLocaleKey(localizationLocale);
    return /*#__PURE__*/ _jsx(IntlProvider, {
        localeKey: localeKey,
        messages: getDictionary(localizationLocale),
        children: children
    });
};
var getDictionary = function(translationLocale) {
    if (dictionaryCache.has(translationLocale)) {
        return dictionaryCache.get(translationLocale);
    }
    var filename = "./node_modules/@faire/web-translations/".concat(translationLocale, ".json");
    try {
        var dictionary = JSON.parse(fs.readFileSync(filename, "utf8"));
        dictionaryCache.set(translationLocale, dictionary);
        return dictionary;
    } catch (e) {
        throw new Error("Failed to read translation file for ".concat(translationLocale, ". File pathname=").concat(filename, ". Error=").concat(e));
    }
};
var dictionaryCache = new Map();
